module.exports = __webpack_public_path__ + "static/media/add-user.c95b1708.svg";